/**
 * One River Tai Chi — Landing Page Scripts
 * Scroll reveal, FAQ accordion, curriculum accordion, video click-to-play.
 */
(function () {
  'use strict';

  /* -------------------------------------------------------
   * 1. Scroll Reveal (IntersectionObserver on .rv elements)
   * ------------------------------------------------------- */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: just show everything
      document.querySelectorAll('.rv').forEach(function (el) {
        el.classList.add('on');
      });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('on');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -32px 0px' });

    document.querySelectorAll('.rv').forEach(function (el) {
      obs.observe(el);
    });
  }

  /* -------------------------------------------------------
   * 2. FAQ Accordion (class-based toggle on .lp-faq-item)
   * ------------------------------------------------------- */
  function initFaqAccordions() {
    document.querySelectorAll('.lp-faq-q').forEach(function (btn) {
      if (btn.dataset.faqInit) return;
      btn.dataset.faqInit = 'true';

      btn.addEventListener('click', function () {
        var item = btn.closest('.lp-faq-item');
        if (!item) return;
        item.classList.toggle('open');
      });
    });
  }

  /* -------------------------------------------------------
   * 3. Curriculum Accordion (class-based toggle on .lp-mod)
   * ------------------------------------------------------- */
  function initCurriculumAccordions() {
    document.querySelectorAll('.lp-mod-hd').forEach(function (hd) {
      if (hd.dataset.modInit) return;
      hd.dataset.modInit = 'true';

      hd.addEventListener('click', function () {
        var mod = hd.closest('.lp-mod');
        if (!mod) return;
        mod.classList.toggle('open');
      });
    });
  }

  /* -------------------------------------------------------
   * 4. Video Click-to-Play (lazy iframe injection)
   * ------------------------------------------------------- */
  function initVideoPlayers() {
    document.querySelectorAll('.lp-vframe[data-video-url]').forEach(function (frame) {
      if (frame.dataset.videoInit) return;
      frame.dataset.videoInit = 'true';

      frame.addEventListener('click', function () {
        var url = frame.dataset.videoUrl;
        if (!url) return;

        var iframe = document.createElement('iframe');
        iframe.src = url;
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('loading', 'lazy');
        iframe.setAttribute('title', frame.dataset.videoTitle || 'Course Preview');

        frame.innerHTML = '';
        frame.appendChild(iframe);
        frame.classList.add('lp-vframe--playing');
      });
    });
  }

  /* -------------------------------------------------------
   * 5. Topbar — add .scrolled class after 60px scroll
   * ------------------------------------------------------- */
  function initTopbar() {
    var bar = document.getElementById('lp-topbar');
    if (!bar) return;

    function onScroll() {
      if (window.scrollY > 60) {
        bar.classList.add('scrolled');
      } else {
        bar.classList.remove('scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once on load
  }

  /* -------------------------------------------------------
   * 6. Smooth Scroll for CTA anchor links
   * ------------------------------------------------------- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      if (link.dataset.smoothInit) return;
      link.dataset.smoothInit = 'true';

      link.addEventListener('click', function (e) {
        var targetId = link.getAttribute('href');
        if (!targetId || targetId.length < 2) return;
        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* -------------------------------------------------------
   * 7. Init
   * ------------------------------------------------------- */
  function init() {
    initScrollReveal();
    initFaqAccordions();
    initCurriculumAccordions();
    initVideoPlayers();
    initTopbar();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when Shopify Theme Editor adds/reloads a section
  document.addEventListener('shopify:section:load', init);

})();
